import { Button, Fab, Tooltip } from "@mui/material";
import {
  Search,
  ArrowBackIos,
  DeleteForever,
  Add,
  Info,
  Cancel,
  Summarize,
  CloseRounded,
  Home,
  SaveAlt,
  RefreshRounded,
  Print,
  Save,
  TaskAltRounded,
  Logout,
  List,
  Edit,
  RemoveRedEye,
  Close,
  AppRegistration,
  ContentCopy,
  EmojiObjects,
  TaskAltOutlined,
  Description,
  Delete,
  Cached,
  HistoryRounded,
} from "@mui/icons-material";
import { MdRecycling, MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";
import { HiOutlineSave } from "react-icons/hi";
import { AiOutlineComment } from "react-icons/ai";
import { FaSyncAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import { BiEdit, BiReset, BiCollapse, BiExpand } from "react-icons/bi";
import { BsFileEarmarkExcel, BsChatFill } from "react-icons/bs";
import { blue } from "@mui/material/colors";
import { I18n, ParseHtml } from "utilities/utilities";
import { I18NextNs } from "enum/enum";
import { BtnProp, ButtonCustomProp } from "./Button";

export const BtnBaseButton = (props: ButtonCustomProp) => {

  const {
    id,
    key,
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    startIcon,
    txt = "",
    // tooltiptxt = "",
    IsCircleWithOutText = false,
    tooltipPlacement = "bottom",
    size = "medium",
    fontColor = '#ffffff',
    bgcolor = "#4b7902",
    bgcolorHover = "#4b7902",
    IsRadius = true,
    isFullwidth = false,
    className = "",
    sx,
    tooltiptxt = ""
  } = props;

  const styleRectangle = txt ? {} : tooltiptxt ? {} : {
    width: "36.5px",
    minWidth: "20px",
    height: "39.5px",
    borderRadius: "8px !important"
  };

  return (
    <Tooltip placement={tooltipPlacement} title={ParseHtml(tooltiptxt != "" ? tooltiptxt : txt)}>
      {!IsCircleWithOutText ?
        <Button
          variant="contained"
          id={id}
          key={key}
          size={size}
          startIcon={startIcon}
          disabled={IsDisabled}
          className={className}
          fullWidth={isFullwidth}
          hidden={IsHidden}
          onClick={onClick}
          sx={(theme) => ({
            ...sx,
            boxShadow: 'none',
            textTransform: 'none',
            border: '1px solid',
            lineHeight: 1.5,
            color: fontColor,
            backgroundColor: bgcolor,
            borderColor: bgcolor,
            borderRadius: IsRadius && txt ? "20px" : "8px",
            ...styleRectangle,
            ":hover": {
              bgcolor: bgcolorHover,
              borderColor: bgcolorHover
            },
            ".Mui-disabled": {
              color: 'rgba(0, 0, 0, 0.26)',
              boxShadow: 'none',
              // backgroundColor: 'rgba(0, 0, 0, 0.12)',
              borderColor: 'rgba(0, 0, 0, 0.12)'
            },
            ".MuiButton-startIcon": txt ? {} : { margin: '0' },
            [theme.breakpoints.down('sm')]: !isFullwidth ? {
              width: "35px",
              minWidth: "35px",
              height: "35px",
              fontSize: "0px",
              lineHeight: "0px",
              "& .MuiButton-startIcon": { margin: 0 }

            }
              : {},
          })}

        >
          {txt}
        </Button>
        :
        <Fab
          id={id}
          key={key}
          size={size}
          className={className}
          onClick={onClick}
          disabled={IsDisabled}
          sx={{
            ...sx,
            zIndex: "1 !important",
            width: 35,
            height: 35,
            color: fontColor,
            backgroundColor: bgcolor,
            borderColor: bgcolor,
            ":hover": {
              bgcolor: bgcolorHover,
              borderColor: bgcolorHover
            },
            ".MuiSvgIcon-root": {
              color: fontColor
            }
          }}
        >
          {startIcon}
        </Fab>
      }
    </Tooltip>
  );
};

export const BtnSave = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Save", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Save />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#33a64c"
      bgcolorHover="#33a64c"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnApprove = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Approve", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sSize = "medium",
    bgcolor = "#33a64c",
    bgcolorHover = "#33a64c",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={sSize}
      startIcon={<TaskAltRounded />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnConfirm = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Confirm", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<TaskAltOutlined />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#1976d2"
      bgcolorHover="#1976d2"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnDelete = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Delete", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sColor = "#ed3847",
    sColorHover = "#ed3847",
    sFontColor = "#ffffff",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<DeleteForever />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={sColor}
      bgcolorHover={sColorHover}
      fontColor={sFontColor}
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnCancelForm = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Cancel", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<CloseRounded />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#ed3847"
      bgcolorHover="#ed3847"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnPreview = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Preview", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Info />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#e39a2d"
      bgcolorHover="#e39a2d"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnClose = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Close", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Cancel />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#8c98ac"
      bgcolorHover="#8c98ac"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnCancel = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Cancel", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<CloseRounded />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#888888"
      bgcolorHover="#888888"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnBack = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Back", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sColor = "#888888",
    sColorHover="#888888"
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<ArrowBackIos />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={sColor}
      bgcolorHover={sColorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnAdd = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Add", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sSize = "medium",
    sColor = "#05a6e8",
    sColorHover = "#05a6e8",
    sFontColor = "#ffffff",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={sSize}
      startIcon={<Add />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={sColor}
      bgcolorHover={sColorHover}
      fontColor={sFontColor}
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnSearch = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Search", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Search />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#0070ff"
      bgcolorHover="#0b5ec9"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnClear = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Clear", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <RefreshRounded />
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#dcdbdb"
      bgcolorHover="#b7b7b7"
      fontColor="#606060"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnHome = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Home", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Home />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#dcdcdc"
      bgcolorHover="#dcdcdc"
      fontColor="#000000"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnEdit = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<BiEdit />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#F6C000"
      bgcolorHover="#F6C000"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnExportExcel = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Excel", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <BsFileEarmarkExcel />,
    tooltiptxt = I18n.SetText("Button.Excel", I18NextNs.labelComponent),
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      // tooltiptxt={tooltiptxt}
      size={"medium"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#34956d"
      bgcolorHover="#1e855b"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      tooltiptxt={tooltiptxt}
    />
  );
};

export const BtnDownload = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Download", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    bgcolor = "#1000f3",
    bgcolorHover = "#1000f3",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<SaveAlt />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnDraft = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Draft", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<HiOutlineSave />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#3cc1ac"
      bgcolorHover="#239b88"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnAdditionnel = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Additionnel", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<List />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#43619D"
      bgcolorHover="#496397"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnRecycle = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Recycle", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<MdRecycling />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#f59a23"
      bgcolorHover="#e6880c"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnNote = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Note", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Summarize />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#f59a23"
      bgcolorHover="#e6880c"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnSend = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Send", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    bgcolor = "#00aeef",
    bgcolorHover = "#0799d0",
    sFontColor = "#ffffff",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<FiSend />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor={sFontColor}
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnRecall = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Recall", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<BiReset />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#f59b26"
      bgcolorHover="#d98c28"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnComment = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Comment", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<AiOutlineComment />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#f7f7ff"
      bgcolorHover="#dfdfea"
      fontColor="#000000"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnNext = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Next", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<MdOutlineNavigateNext />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#05a6e8"
      bgcolorHover="#0c93cb"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnPrevious = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Previous", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<MdOutlineNavigateBefore />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#05a6e8"
      bgcolorHover="#0c93cb"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnCollapse = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Collapse", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<BiCollapse />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#4caf50"
      bgcolorHover="#3d9840"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnExpand = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Expand", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<BiExpand />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#668ecf"
      bgcolorHover="#5379b7"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnLoadSync = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.LoadSync", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<FaSyncAlt />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#e3b43f"
      bgcolorHover="#d3a83b"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnReject = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Reject", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      // startIcon={<Undo />}
      startIcon={<Close />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#ed3847"
      bgcolorHover="#ed3847"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnDes = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Description", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Description />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#5197ff" bgcolorHover='#0f80d7'
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnExportExcelTemplate = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Excel", I18NextNs.labelComponent),

    // txt = "Excel",
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <Description />
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={blue[500]}
      bgcolorHover={blue[700]}
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};

export const BtnLogout = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Logout", I18NextNs.labelComponent),
    IsCircleWithOutText = true,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<Logout />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={"#ed3847"}
      bgcolorHover={"#ed1325"}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnDuplicate = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Duplicate", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    bgcolor = "#e7672c",
    bgcolorHover = "#D15E28",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<ContentCopy />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
}

export const BtnAddRequestLeave = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Add", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sSize = "medium",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={sSize}
      startIcon={<Description />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#05a6e8"
      bgcolorHover="#05a6e8"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnEditData = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sSize = "medium",
    bgcolor = "#d45a27",
    bgcolorHover = "#a64218",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={sSize}
      startIcon={<Edit />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnPreviewForm = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Preview", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<RemoveRedEye />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#e39a2d"
      bgcolorHover="#e39a2d"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};


export const BtnAddProject = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.AddProject", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<AppRegistration />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#0e937b"
      bgcolorHover="#167665"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnRemark = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = "หมายเหตุ",
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"small"}
      startIcon={<BsChatFill />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="tranparent"
      bgcolorHover="tranparent"
      fontColor="#5598fc"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      sx={{
        width: "30 !important",
        height: "30 !important",
        backgroundColor: "tranparent !important",
        borderColor: "tranparent !important",
        ":hover": {
          bgcolor: "tranparent !important",
          borderColor: "tranparent !important"
        }
      }}
    />
  );
};

export const BtnSendRequest = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Send", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    bgcolor = "#33a64c",
    bgcolorHover = "#33a64c",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<FiSend />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={bgcolor}
      bgcolorHover={bgcolorHover}
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnExample = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Example", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <EmojiObjects />
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#3cc1ac"
      bgcolorHover="#239b88"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnPrint = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = "พิมพ์เอกสาร",
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <Print />
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#70b603"
      bgcolorHover="#5f9608"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};


export const BtnDeleteTable = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Delete", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    sColor = "#f30800",
    sColorHover = "#d8352f",
    sFontColor = "#ffffff",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"small"}
      startIcon={<Delete />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor={sColor}
      bgcolorHover={sColorHover}
      fontColor={sFontColor}
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      key={props.key}
    />
  );
};

export const BtnEditTable = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"small"}
      startIcon={<Edit />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#ffc107"
      bgcolorHover="#cc9900"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      key={props.key}
    />
  );
};

export const BtnViewTable = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.View", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"small"}
      startIcon={<Description />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#1976d2"
      bgcolorHover="#0946a2"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      key={props.key}
    />
  );
};

export const BtnClearTable = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Clear", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <Cached />
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"small"}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#f7f7f7"
      bgcolorHover="#f3f3f3"
      fontColor="#e90000"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
      key={props.key}
    />
  );
};

export const BtnVersion = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = "เวอร์ชัน",
    IsCircleWithOutText = false,
    IsRadius = true,
    icon = <HistoryRounded />,
    sSize = "medium",
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={sSize}
      startIcon={icon}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#169bd5"
      bgcolorHover="#1a82b0"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

export const BtnConfirmSelect = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Save", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<TaskAltOutlined />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#51cc6c"
      bgcolorHover="#51cc6c"
      fontColor="#ffffff"
      tooltipPlacement="bottom"

      className={props.className}
      id={props.id}
    />
  );
};